import * as React from 'react';
import { withRouter, matchPath } from 'react-router';

import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import { ROUTES } from '@constants';

import { ICurrentUser, UiStore } from '@stores';

import { App as AppBase, IAppBaseProps } from '@base/App';
import { ScrollToTop } from '@base/components';
import { Error } from '@base/components/Error';
import { PageTitle } from '@base/components/PageTitle';
import { EStore } from '@base/enums';

import { MainMenu } from '@components';
import { AppProviders } from '@components/AppProviders';
import { TopMenu } from '@components/TopMenu';

import { Router, RouterPopups, routes } from './Router';

import * as s from './App.scss';

interface IAppProps extends IAppBaseProps {
	currentUserStore?: ICurrentUser;
	uiStore?: UiStore;
}

@inject(
	EStore.CURRENT_USER,
	EStore.UI,
)
@observer
export class AppComponent extends React.PureComponent<IAppProps> {

	render() {
		const { currentUserStore, location } = this.props;
		const isAppView = Boolean(currentUserStore.isUserAuth &&
			matchPath(location.pathname, { path: ROUTES.APP }));

		return <AppBase
			{...this.props}
			routes={routes}
			render={({ error }) => {
				return (
					<div className={classNames(
						s.app,
						{ [s.appFixed]: this.props.uiStore.slidingMenu.isVisible },
					)}>
						<PageTitle/>
						<AppProviders>
							{error
								? <Error error={error}/>
								: <>
									{isAppView ? null : <TopMenu/>}
									<div className={s.innerWrapper}>
										<ScrollToTop/>
										{isAppView ? null : <MainMenu/>}
										<Router/>
										<RouterPopups/>
									</div>
								</>
							}
						</AppProviders>
					</div>
				);
			}}
		/>;
	}

}

export const App = withRouter(AppComponent);
